import React from 'react';
import { Workflow, Zap, Home } from 'lucide-react';

// Logo Option 1: Modern with icon and stacked text
export const LogoOption1 = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="relative">
        <div className="w-10 h-10 bg-gradient-to-br from-amber-400 to-amber-600 rounded-lg flex items-center justify-center shadow-lg">
          <Workflow className="w-6 h-6 text-white" strokeWidth={2.5} />
        </div>
      </div>
      <div className="flex flex-col leading-none">
        <span className="text-2xl font-bold tracking-tight text-gray-900">EZ Flow</span>
        <span className="text-xs font-medium tracking-widest text-amber-600 uppercase">Transaction Coordination</span>
      </div>
    </div>
  );
};

// Logo Option 2: Sleek horizontal with bolt icon
export const LogoOption2 = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex items-center">
        <Zap className="w-8 h-8 text-amber-500 fill-amber-500" strokeWidth={2} />
      </div>
      <div className="flex items-baseline gap-1">
        <span className="text-3xl font-extrabold text-gray-900">EZ</span>
        <span className="text-3xl font-light text-gray-600">Flow</span>
        <span className="text-sm font-semibold text-amber-600 uppercase tracking-wider ml-1">TC</span>
      </div>
    </div>
  );
};

// Logo Option 3: Professional with house icon
export const LogoOption3 = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="relative">
        <div className="w-11 h-11 rounded-full bg-gray-900 flex items-center justify-center border-2 border-amber-500">
          <Home className="w-6 h-6 text-amber-500" strokeWidth={2.5} />
        </div>
      </div>
      <div className="flex flex-col leading-none">
        <span className="text-2xl font-bold text-gray-900">
          <span className="text-amber-600">EZ</span> Flow TC
        </span>
        <span className="text-xs text-gray-500 tracking-wide mt-0.5">Transaction Coordination Experts</span>
      </div>
    </div>
  );
};

// Footer Logo: Same design but for dark backgrounds
export const FooterLogo = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="relative">
        <div className="w-11 h-11 rounded-full bg-gray-900 flex items-center justify-center border-2 border-amber-500">
          <Home className="w-6 h-6 text-amber-500" strokeWidth={2.5} />
        </div>
      </div>
      <div className="flex flex-col leading-none">
        <span className="text-2xl font-bold text-white">
          <span className="text-amber-500">EZ</span> Flow TC
        </span>
        <span className="text-xs text-gray-400 tracking-wide mt-0.5">Transaction Coordination Experts</span>
      </div>
    </div>
  );
};

// Currently active logo (change this to switch between options)
export const Logo = LogoOption3;
